import { useEffect, useState } from 'react';
import { SessionParticipant, SessionTiming } from '../../types/videocall.types';

export const useSessionTiming = (participant: SessionParticipant | null) => {
  const [sessionTiming, setSessionTiming] = useState<SessionTiming | null>(null);

  useEffect(() => {
    if (!participant) return;

    const startTimestamp = new Date(participant.time).getTime();
    const bufferTime = [30, 60].includes(participant.sessionLength) ? 15 : 0;

    setSessionTiming({
      sessionLength: participant.sessionLength,
      bufferTime,
      startTimestamp,
    });
  }, [participant]);

  return sessionTiming;
};

export default useSessionTiming;